import React from "react";
import {
  Modal,
  Button,
  Box,
  Typography,
  IconButton,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGenerateClipping } from "../../../hooks/useClipping/usePostGenerateClipping";
import { useGenerateIndexClipping } from "../../../hooks/useClipping/usePostGenerateIndexClipping";
import { useGenerateReplacedClipping } from "../../../hooks/useClipping/usePostReplacedClipping";
import { postDocumentClippingURL } from "../../../utils/ConstantsURL";

const GenerateClipping = ({
  open,
  onClose,
  token,
  id_documento,
  fecha,
  nameDocument,
  addToDownloadQueue,
  addToHiperlyncQueue,
}) => {
  const { generateClipping } = useGenerateClipping(token, addToDownloadQueue, addToHiperlyncQueue);

  const { generateIndexClipping, loading } = useGenerateIndexClipping(token, addToDownloadQueue);
  
  const { generateReplacedClipping } = useGenerateReplacedClipping(token, addToDownloadQueue);

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          maxWidth: "90vw",
          maxHeight: "90vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          borderRadius: "12px",
          boxShadow: 24,
          p: 3,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <DialogTitle
            sx={{ textAlign: "left", fontWeight: "bold", fontSize: "1.2rem", color: "black", pl: 0 }}
          >
            Descarga de Clipping
          </DialogTitle>
          <IconButton onClick={onClose} sx={{ color: "gray" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography sx={{ mt: 2, mb: 3, color: "black" }}>
          El proceso de generación del clipping puede tardar unos minutos.
          Puedes continuar con tus actividades mientras se completa el proceso.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          {(id_documento === "1000854" || id_documento === "1000166" || id_documento === "1000248") && (
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                generateIndexClipping(id_documento, fecha, nameDocument, onClose)
              }
              sx={{ px: 3, mr: 1 }}
            >
              {loading ? "Generando..." : "Generar Formato de Índice"}
            </Button>
          )}
          {id_documento === "1000932" && (
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                generateReplacedClipping(id_documento, fecha, nameDocument, onClose)
              }
              sx={{ px: 3, mr: 1 }}
            >
              Generar Reemplazo de Contenido
            </Button>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              generateClipping(
                id_documento,
                fecha,
                nameDocument,
                false,
                [],
                onClose,
                {
                  cover: true,
                  index: false,
                  dividers: true,
                },
                true,
                postDocumentClippingURL,
              )
            }
            sx={{ px: 3, mr: 1 }}
          >
            Generar Hipervínculo
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              generateClipping(
                id_documento,
                fecha,
                nameDocument,
                false,
                [],
                onClose,
                {
                  cover: true,
                  index: false,
                  dividers: true,
                },
                false,
                postDocumentClippingURL,
              )
            }
            sx={{ px: 3 }}
          >
            Generar Clipping
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default GenerateClipping;